import { Grid } from "@chakra-ui/react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { FontCss } from "./theme";

import { AuthHandler, GlobalPageHeader, ProtectedRoute } from "./components";
import {
  Auth,
  AuthCallback,
  Home,
  Sandbox,
  SceneDetail,
  Scenes,
  NotFound,
  Explore,
  Validate,
  Terms,
  Privacy
} from "./pages";
import ContextProviders from "./context";

function App() {
  return (
    <ContextProviders>
      <FontCss />
      <BrowserRouter>
        <AuthHandler />
        <Grid h="100vh" maxH="100vh" templateRows="max-content 1fr">
          <GlobalPageHeader />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login/" element={<Auth />} />
            <Route
              path="/auth/:authProvider/callback/"
              element={<AuthCallback />}
            />
            <Route path="/scenes/" element={<ProtectedRoute />}>
              <Route path="/scenes/" element={<Scenes />} />
              <Route path="/scenes/:sceneId/" element={<SceneDetail />} />
              <Route path="/scenes/:sceneId/validate/" element={<Validate />} />
              <Route path="/scenes/:sceneId/validate/:inferenceId" element={<Validate />} />
            </Route>
            <Route path="/explore/" element={<Explore />} />
            <Route path="/terms/" element={<Terms />} />
            <Route path="/privacy/" element={<Privacy />} />
            <Route path="/sandbox/" element={<Sandbox />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Grid>
      </BrowserRouter>
    </ContextProviders>
  );
}

export default App;
